import { Injectable } from '@angular/core'
import { CacheService } from './cache.service'
import { BehaviorSubject, ReplaySubject, Subject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class PurchaseHistoryService {
  constructor(private cacheService: CacheService) {}
  products$: any = new ReplaySubject<any>(1)
  invoice$:any =new Subject<any>
  getPurchaseHistory() {
    this.cacheService.get('sdpr.getInvoices', {pageSize:1000,pageNo:1}).then((data) => {
      this.products$.next(data)
      return this.products$
    })
  }
  downloadInvoice(data:string){
    // console.log(data,"i am from service")
    this.cacheService.get('sdpr.getSubscriptionDocument', {documentId:data, responseType: "application/json"}, false).then((data) => {
       this.invoice$.next(data)
     return this.invoice$
    })
  }
}
